import router from '../routes';
import Backend from './Backend';

// To be fixed by the script pre-processor
let BASE_URL = '/* @echo MIA_BASE_URL */';
let course = null;
let TOKEN;

// Ensure empty response is valid json
$.ajaxSetup({
    converters: {
        "text json": function (response) {
            return (response == "") ? null : JSON.parse(response);
        },
    },
});

let self = {
    'request': (method, url, data = null, auth = true, isRetry = false) =>
    {
        if(method !== 'GET' && data && !isRetry)
        {
            data = JSON.stringify(data);
        }

        if (!TOKEN) {
            console.log('We need a MIA token');
            
            // Get a token
            return Backend.getMIAToken()
                .then((token) =>
                {
                    BASE_URL = Backend.getMIAURL();

                    TOKEN = token;                 
                    
                    // Retry the request - if it errors again, fail hard
                    return self.request(method, url, data, true, true);
                });
        }

        return $.ajax({
            'type': method,
            'url': BASE_URL + url,
            'headers': { 'Authorization': 'Bearer ' + TOKEN },
            'contentType': 'application/json',
            'data': data,
            'dataType': 'json'
        }).catch(response =>
        {
            // Check for various token errors
            if(response.responseJSON)
            {
                let error = response.responseJSON.error;
                if (error === 'token_expired')
                {
                    // Get a new token
                    return Backend.getMIAToken()
                        .then((token) =>
                        {
                            TOKEN = token;

                            // Retry the request - if it errors again, fail hard
                            return self.request(method, url, data, true, true);
                        });
                }
                else if(error === 'token_invalid' || error === 'user_not_found')
                {
                    // Wipe token
                    Auth.logout();

                    // Back to login
                    router.push({ 'name': 'login' });
                    return;
                }
            }

            // Throw it down the chain
            throw response;
        });
    },

    'removeToken': () => {
        TOKEN = null;
    },
    
    'getMemberships': () => {
        return self.request('GET', 'account/memberships');
    },

    'getRoles': () =>
    {                
        console.log('getRoles');
        return self.request('GET', 'course/' + course.code + '/roles');        
    },

    'getCourse': (courseCode) =>
    {
        if(courseCode) {
            return self.request('GET', 'course/' + encodeURIComponent(courseCode) + '/');
        } else {
            return self.request('GET', 'course/' + encodeURIComponent(course.code) + '/');
        }        
    },

    'setActiveCourse': (activeCourse) => 
    {
        course = activeCourse;
    },

    'findActiveCourse': (courses, current = 0) =>
    {    
        course = courses[current];

        console.log('findActiveCourse', course, course.code, current);

        return self.getRoles().then((roles) => {
            if (roles.length > 0)
                return course;
            
            if (current >= courses.length) {
                console.log('findActiveCourse:reject')
                return Promise.reject();
            }
            else
                return self.findActiveCourse(courses, current + 1);
        });
    },

    'submitEvent': (category, type, parameter) =>
    {
        let eventData = {
            'category': category,
            'type': type,
            'parameter': parameter
        };

        console.log('submitting', eventData);

        return self.request('POST', 'course/' + course.code + '/event', eventData);
    },

    'submitKeepAlive': () =>
    {
        return self.request('POST', 'course/' + course.code + '/event/keep-alive');        
    },

    'downloadParameters': (names) =>
    {
        let get = '';
        if ((Array.isArray(names) && names.length > 0) || (typeof(names) === 'object' && Object.keys(names).length > 0))
            get = '?' + $.param($.map(names, function(val) { return {name: 'name', value: val};}));

        return self.request('GET', 'course/' + course.code +  '/parameters' + get)            
            .then(function(data)
            {
                let userData = {};

                for(let i = 0; i < data.length; ++i)
                {
                    userData[data[i].name] = data[i].value;
                }
                
                return userData;
            });
    },

    'uploadParameters': (parameters) =>
    {
        let parameterToSend = $.map(parameters, function(val, key) { return {name: key, value: val}; });
        return self.request('POST', 'course/' + course.code + '/parameters', parameterToSend);
    },

    'uploadParameter': (parameterName, value) =>
    {
        let parameterToSend = [{
            name: parameterName,
            value: value
        }];

        return self.request('POST', 'course/' + course.code + '/parameters', parameterToSend);
    },

    'deleteParameters': (names) =>
    {
        return self.request('POST', 'course/' + course.code + '/parameters/delete', JSON.stringify(names));
    },

    'getAssignmentList': (resourcegroupCode) =>
    {
        return self.request('GET', 'resourcegroups/' + encodeURIComponent(resourcegroupCode) + '/assignments');
    },

    'getAssignment': (assignmentCode) =>
    {
        return self.request('GET', 'assignments/' + encodeURIComponent(assignmentCode) + '/');
    },
    
    'getReport': (reportCode, parameters = undefined) =>
    {
        return self.request('POST', 'report/' + encodeURIComponent(reportCode) + '', parameters);
    },

    'getAssignmentSession': (assignmentCode, sid = undefined) =>
    {
        return self.request('GET', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/' + sid)
            .fail(() => 
            {
                console.log('No existing assignmentsession, creating new one');
                return self.createAssignmentSession(assignmentCode);
            });
    },

    'getAssignmentSessions' : (assignmentCode) => 
    {
        return self.request('GET', 'assignments/' + encodeURIComponent(assignmentCode) + '/sessions');
    },

    'getAssignmentSessionLatest': (assignmentCode) =>
    {
        return self.request('GET', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/latest')
            .catch((jqXHR) => 
            {
                console.log('No latest assignmentsession');    
                if (jqXHR.status === 404) {
                    return null;
                } else {
                    throw jqXHR;
                }
            });
    },

    'createAssignmentSession': (assignmentCode) =>
    {
        return self.request('POST', 'assignments/' + encodeURIComponent(assignmentCode) + '/session');
    },

    'postAssignmentSessionPosition': (assignmentCode, sid, position) =>
    {
        return self.request('POST', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/' + sid + '/position', position);
    },       

    'getAssignmentSessionAnswers': (assignmentCode, sid) =>
    {
        return self.request('GET', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/' + sid + '/answers');
    },

    'updateAssignmentSessionAsnwers': (assignmentCode, sid, answers) =>
    {
        if (!Array.isArray(answers)) {
            answers = [answers];
        }

        if (sid === undefined) {
            return self.request('POST', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/answers', answers);
        } else {
            return self.request('POST', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/' + sid + '/answers', answers);
        }
    },

    'finishAssignmentSession': (assignmentCode, sid) =>
    {
        return self.request('POST', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/' + sid + '/finish');
    }, 

    'getAssignmentResults': (assignmentCode) =>
    {
        return self.request('GET', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/results');
    },

    'getAssignmentSessionResults': (assignmentCode, sid) =>
    {
        return self.request('GET', 'assignments/' + encodeURIComponent(assignmentCode) + '/session/' + encodeURIComponent(sid) + '/results');
    },

    'submitAssignmentResult': (assignmentCode, lineItemCode, result) =>
    {
        return self.request('POST', 'assignments/' + encodeURIComponent(assignmentCode) + '/results/' + lineItemCode, result);
    },

    'getOrchestrationSession': (sid) => 
    {
        return self.request('GET', 'orchestration/session/' + encodeURIComponent(sid));
    },

    'postOrchestrationSession': (sid, data = undefined) =>
    {
        return self.request('POST', 'orchestration/session/' + encodeURIComponent(sid), data);
    },

    'startOrchestration': (orchestrationCode, entryLabel = undefined) =>
    {
        if(entryLabel)
            entryLabel = encodeURIComponent(entryLabel) + '/';
            
        return self.request('GET', 'course/' + encodeURIComponent(course.code) + '/orchestration/' + encodeURIComponent(orchestrationCode) + '/start/' + entryLabel);
    },

    //Helpers

    'getChoiceByLabel': (choices, label) => {
        return choices.find(c => c.label == label);
    },
};

export default self;
